module.exports = __webpack_public_path__ + "media/images/brand/logo-admin-59e27a82670ed08d10227632aeee691e.png";